import React, { useState } from 'react';
import PrintForm from '../components/PrintForm';
import { FaPlus } from 'react-icons/fa';
import { FaPrint } from 'react-icons/fa';
import { validateForms } from '../lib/validation';
import { useStateContext } from '../contexts/ContextProvider';
import { useNavigate } from 'react-router-dom';
import { getPrintingPrice } from '../lib/utils';

const Print = () => {
  const { cartItems, setCartItems } = useStateContext();
  const [fileInputs, setFileInputs] = useState(
    cartItems.documents.length > 0 ? cartItems.documents.map((doc) => doc) : [{
    docNumber: 1
  }]);
  const navigate = useNavigate();

  // Function to add more file inputs
  const addFileInput = () => {
    setFileInputs([
      ...fileInputs,
      {
        docNumber: fileInputs.length + 1
      }
    ]);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    // Set errors to null initially
    setFileInputs(fileInputs.map(fileInput => ({
      ...fileInput,
      errors: null
    })));
    const errors = validateForms(fileInputs);
    if (errors.length > 0) {
      setFileInputs(fileInputs.map(fileInput => {
        let potentialError = errors.filter(error => error.docNumber === fileInput.docNumber);
        potentialError = potentialError.length === 1 ? potentialError[0] : null;
        if (potentialError) {
          return {
            ...fileInput,
            errors: {
              fileError: potentialError.fileError,
              paperFormatError: potentialError.paperFormatError,
              printOptionError: potentialError.printOptionError,
              quantityError: potentialError.quantityError
            }
          };
        }
        return fileInput;
      }))
      return;
    }
    const price = await getPrintingPrice(fileInputs);

    setCartItems({
      ...cartItems,
      documents: fileInputs.map(fileInput => ({
        docNumber: fileInput.docNumber,
        file: fileInput.file,
        quantity: fileInput.quantity,
        paperFormat: fileInput.paperFormat,
        printOption: fileInput.printOption,
        printColor: fileInput.printColor,
        paperOrientation: fileInput.paperOrientation,
        addCoverPage: fileInput.addCoverPage,
        pageRange: fileInput.pageRange,
        additionalNotes: fileInput.additionalNotes,
        paperFasteningChoice: fileInput.paperFasteningChoice,
        price: price
      }))
    })
    navigate('/cart');
  };

  return (
    <div className='w-full bg-gray-200 pb-10'>
      <h1 className="w-11/12 mx-auto text-left text-2xl font-bold py-10">Document(s) to Print:</h1>

        <form>
          {fileInputs.map((fileInput, index) => (
              <PrintForm
                key={index}
                document={{ ...fileInput }}
                errors={fileInput.errors}
                setFileInputs={setFileInputs}
              />
          ))}
        </form>
        
        {/* Button to add more file inputs */}
        <button
          type="button"
          className="w-11/12 mx-auto flex items-center mt-4 text-blue-500 font-semibold hover:text-blue-700"
          onClick={addFileInput}
        >
          <FaPlus className="mr-2" />
          Add another file
        </button>

        <div className='w-11/12 mx-auto sticky bottom-2 flex flex-row justify-end'>
            <button
                type="submit"
                className=" bg-blue-400 text-white font-semibold py-2 px-4 mx-2 rounded-md hover:bg-blue-600 flex items-center justify-center"
                onClick={handleFormSubmit}
            >
                <FaPrint className="mr-2" />
                Print
            </button>
        </div>
    </div>
  );
};

export default Print;
